export default __webpack_public_path__ + "static/media/22.ea107c5b.jpg";